import PageFieldDescription from './PageFieldDescription';

export default PageFieldDescription;
